import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { ContentContainer } from '../base/contentContainer/contentContainer';
import { tableDataStyles, tableHeaderStyles, tableRowStyles, tableStyles } from '../base/table/table';
import { H4, asAnchor, asHeading5 } from '../base/typography';

interface Props {
	title: string;
}

const CookieDeclaration: FC<Props> = ({ title }) => {
	useEffect(() => {
		const cookiehub = (window as any)?.cookiehub;
		if (cookiehub?.renderDeclaration) {
			cookiehub.renderDeclaration();
		}
	}, []);

	return (
		<Root>
			<ContentContainer>
				<H4>{title}</H4>
				<DeclarationWrapper className="cookiehub-declaration"></DeclarationWrapper>
			</ContentContainer>
		</Root>
	);
};

export default CookieDeclaration;

const Root = styled.div`
	margin-top: 150px;
`;

const DeclarationWrapper = styled.div`
	margin-top: 3rem;
	a {
		${asAnchor};
	}
	strong {
		${asHeading5};
		display: block;
		margin-top: 3rem;
		margin-bottom: 1rem;
		line-height: 32px;
	}
	dt {
		font-weight: ${({ theme }) => theme.fonts.weight.bold};
		margin-top: 1rem;
	}
	dd {
		margin-left: 0;
		margin-bottom: 0.5rem;
	}
	table {
		${tableStyles};
		margin-bottom: 40px;
	}
	tr {
		${tableRowStyles};
	}
	th {
		${tableDataStyles};
		${tableHeaderStyles};
	}
	td {
		${tableDataStyles};
	}
`;
